<div class="pdf-reader">
    <h1 class="mat-display-2">Programm 2023</h1>

    <div class="download">
        <a href="{{ pdfSource }}" download>Herunterladen</a>
    </div>

    <div class="content-page">
        <pdf-viewer
            [src]="pdfSource"
            [show-all]="false"
            [page]="page"
            (after-load-complete)="callBackFn($event)"
            [original-size]="false"
            [render-text]="true">
        </pdf-viewer>
    </div>

    <div *ngIf="isLoaded" class="actions">
        <button mat-flat-button (click)="prevPage()" [disabled]="page === 1">
            <mat-icon>arrow_back_ios</mat-icon>
        </button>
        <span>{{ page }} / {{ totalPages }}</span>
        <button mat-flat-button (click)="nextPage()" [disabled]="page === totalPages">
            <mat-icon>arrow_forward_ios</mat-icon>
        </button>
    </div>
</div>